import { ValidatorFn } from '@angular/forms';
import { ExtendedFormControl } from '../extended-form-control.class';

export class TextControl extends ExtendedFormControl {
    readonly inputType = 'text';

    constructor(name: string, value: string = '', validations: ValidatorFn[] = [], disabled = false) {
        super(name, value, validations, disabled);
    }
}
